module.exports = __webpack_public_path__ + "img/deco-heart-green.06c230e.svg";